import React, { useContext, useEffect } from "react";
import { ProjectEntityGridButtons } from "../../Projects/ProjectsHelper";
import { ProjectsLink } from "../../../Helpers/HooksHelper";
import { ConnectedClientOrigin } from "../../Origin/ClientOrigin";
import { ConnectedAccountPopup } from "../../Origin/AcountPopup";
import { useProject } from "../../../Hooks/EntityHooks";
import {
  ReportsDateProvider,
  DashboardEmptyResponse,
  DashboardTable,
  DashboardTitle
} from "../Dashboard";
import { Tr } from "../../../Components/Table";
import { spaceProjectsSchema } from "../../../config/schema";
import LoaderSpinner from "../../../Components/Loader/LoaderSpinner/LoaderSpinner";
import { faFileArchive, faCog } from "@fortawesome/pro-light-svg-icons";
import RelativeTime from "../../../Components/RelativeTime/RelativeTime";
import { FormattedMessage } from "react-intl";
import { useDashboardQuery } from "../DashboardQueryHelper";
import { useSidebar } from "../../../Components/Sidebar/SidebarV2";
import { DashboardSettingsContext } from "../DashboardLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DashboardCardSettingsForm, {
  handleIntervalCalculation
} from "../DashboardCardSettingsForm";
import Button from "../../../Components/Button/Button";

const columns = [
  {
    minWidth: 120,
    width: 120,
    Cell: (value) => <ProjectEntityGridButtons entity={value} />
  },
  {
    title: "Id",
    Cell: ({ Id }) => <ProjectsLink id={Id}>{Id}</ProjectsLink>
  },
  {
    maxWidth: 300,
    title: <FormattedMessage id={"NAME"} />,
    Cell: ({ Name }) => <span className="text-black">{Name}</span>
  },
  {
    maxWidth: 200,
    title: <FormattedMessage id={"ACCOUNT"} />,
    Cell: ({ Client, IndirectClient }) => (
      <ConnectedClientOrigin client={Client || IndirectClient} />
    )
  },
  {
    title: <FormattedMessage id={"MANAGER"} />,
    Cell: ({ Manager }) => <ConnectedAccountPopup account={Manager} />
  },
  {
    title: <FormattedMessage id={"END_DATE"} />,
    Cell: ({ EndDate }) => <RelativeTime date={EndDate} />
  }
];

const ContractTr = ({ value, ...rest }) => {
  const contract = useProject(value);

  return <Tr value={contract} {...rest} />;
};
const lS_Group = "dashboard-layout-projetos";
const AlmostOutOfTimeProjects = (props) => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "AlmostOutOfTimeProjects";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);
  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, loading, error } = useDashboardQuery(
    `Dashboard/Services/Projects/AlmostExpired?top=15&days=60&todate=${
      DataReports[0] === "Projects"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Projects"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Projects"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`,
    [spaceProjectsSchema],
    { cache: false }
  );

  const buildBody = () => {
    if (loading || error)
      return <LoaderSpinner size="sm text-secondary" center />;

    if (data?.length === 0)
      return (
        <DashboardEmptyResponse className="h-100" type="projects">
          <FormattedMessage id={"EMPTY_PROJECTS"} />
        </DashboardEmptyResponse>
      );

    return (
      <DashboardTable TrComponent={ContractTr} columns={columns} data={data} />
    );
  };
  const user =
    DataReports[0] === "Projects" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  return (
    <React.Fragment>
      <DashboardTitle
        text={<FormattedMessage id={"ALMOST_EXPIRED_PROJECTS"} />}
        icon={faFileArchive}
      />
      {DataReports[0] !== "Projects" && (
        <div className="d-flex px-4 justify-content-between align-items-center">
          <div className="mb-2">
            <span className="ar-dashboard-description">
              {Settings.Interval ? (
                <FormattedMessage id={Settings.Interval.title} />
              ) : (
                <FormattedMessage id={"ALL"} />
              )}
            </span>
            <span className="ar-dashboard-description ml-1">
              | <FormattedMessage id={"SCOPE"} />:
            </span>
            <span className="text-primary pl-1 fs-14">{user}</span>
          </div>
          <Button
            className="ar-dashboard-card-settings-link"
            vType="link-primary"
            onClick={() =>
              openSidebar(
                <DashboardCardSettingsForm
                  lS_Field={lS_Field}
                  lS_Group={lS_Group}
                  Settings={Settings}
                  closeSidebar={closeSidebar}
                  Title={"PROJECTS_DEADLINE_RISK"}
                  handleChanges={handleLayoutChange}
                  AvailableSettings={{
                    interval: true,
                    scope: true,
                    pipeline: false
                  }}
                />
              )
            }
          >
            <FontAwesomeIcon icon={faCog} />
          </Button>
        </div>
      )}
      {buildBody()}
    </React.Fragment>
  );
};

export default AlmostOutOfTimeProjects;
